import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeApp';
import { LANGUAGES } from 'Jsx/global.d';

import App from './App';
import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';
import { FREE_COURSES_PAGE_KEY, initialStatePageKey } from './constants';
import getInitialState from './getInitialState';

const appConfig: Params = {
  App,
  getInitialState,
  initialStatePageKey,
  i18nConfig: {
    pageKey: FREE_COURSES_PAGE_KEY,
    defaults: {
      ...localeEs,
      ...localePt,
    },
  },
  extraState: {
    isPtLanding: window.__INITIAL_STATE__.LANGUAGE_KEY === LANGUAGES.PT,
  },
};

// if (module.hot) {
//   module.hot.accept('./App.tsx', function() {
//     initializeApp(appConfig);
//   });
// }

initializeApp(appConfig);
